import { observable, runInAction } from "mobx"
import { interval } from "rxjs"

import { Model } from "@/lib/Model.ts"

import type { LlmQuota } from "@/lib/client/generated/TypeDefinitions.ts"
import type { OrgContext } from "@/lib/context.ts"


export class OrgQuotaModel extends Model {
  readonly quota = observable.box<LlmQuota | null>(null)

  constructor(private readonly context: OrgContext) {
    super("OrgQuotaModel")

    void this.fetchQuota()

    const subscription = interval(60000)
      .subscribe(() => this.fetchQuota())

    this.lifetime.add(subscription, "OrgQuotaModel:fetchQuota")
  }

  private async fetchQuota() {
    runInAction(() => this.isLoading.set(true))

    try {
      const value = await this.context.queries.getOrgQuota()
      runInAction(() => this.quota.set(value))
    } finally {
      runInAction(() => this.isLoading.set(false))
    }
  }
}